<app-protected-content [requiredRoles]="requiredRoles">
  @let data = (data$ | async) || [];
  @let columns = (columnConfig$ | async) || [];
  <htx-table [data]="data" [columns]="columns" emptyMessage="organization.overview.noRequests">
  </htx-table>

  <ng-template #columnAdmissionState let-row>
    @let organization = getTyped(row);
    @let status = organization.admissionState;
    <htx-badge
      [text]="'organization.control.admissionState.options.' + status | transloco"
      [variant]="
        status === AdmissionState.PENDING
          ? 'warning'
          : status === AdmissionState.APPROVED
            ? 'success'
            : 'danger'
      "
    >
    </htx-badge>
  </ng-template>

  <ng-template #columnActivityState let-row>
    @let organization = getTyped(row);
    @let status = organization.activityState;
    <htx-badge
      [text]="'organization.control.activityState.options.' + status | transloco"
      [variant]="status === ActivityState.ACTIVE ? 'success' : 'danger'"
    >
    </htx-badge>
  </ng-template>

  <ng-template #columnActions let-row>
    @let organization = getTyped(row);
    <div class="action-buttons">
      <htx-button
        variant="tertiary"
        icon="visibility"
        [iconOnly]="true"
        tooltip="Anzeigen"
        (click)="goToDetails(organization)"
      ></htx-button>
      @if (canEditOrganizations) {
        <htx-button
          variant="tertiary"
          icon="edit"
          [iconOnly]="true"
          tooltip="Bearbeiten"
          (click)="edit(organization)"
        ></htx-button>
      }
    </div>
  </ng-template>
</app-protected-content>
